import { GraphQLClient } from 'graphql-request';

const getDatoGraphqlEndpoint = () => {
  const url = process.env.NEXT_PUBLIC_API_URL!.replace(
    /https:\/\/([\w\.]+)/,
    'https://datocms.$1/graphql',
  );
  return url;
};

export const datoClient = (
  { preview }: { preview?: boolean } = { preview: false },
  token?: string,
) => {
  const url = getDatoGraphqlEndpoint();
  return new GraphQLClient(url, {
    headers: {
      Authorization: `Bearer ${token ?? process.env.NEXT_PUBLIC_DATOCMS_FRONTEND_TOKEN}`,
      'X-Exclude-Invalid': 'true',
      ...(process.env.NEXT_PUBLIC_DATO_ENV
        ? { 'X-Environment': process.env.NEXT_PUBLIC_DATO_ENV }
        : {}),
      ...(preview ? { 'X-Include-Drafts': 'true' } : {}),
    },
  });
};
